import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rehab-solution-front-end/src/components/ui/loading-dot.tsx");
